import { createSlice } from '@reduxjs/toolkit';
import { IntensityState } from '../../types/intensity';

const initialState: IntensityState = {
  isLoading: false,
  intensityList: {},
  intensityListParams: {},
  intensity: null,
};

const slice = createSlice({
  name: 'country',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    resetError(state) {
      state.error = undefined;
    },

    getIntensityListSuccess(state, action) {
      state.isLoading = false;
      state.intensityList = action.payload;
    },

    setIntensityListParams(state, action) {
      state.intensityListParams = action.payload;
    },

    getIntensitySuccess(state, action) {
      state.isLoading = false;
      state.intensity = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  startLoading,
  hasError,
  resetError,
  getIntensityListSuccess,
  getIntensitySuccess,
  setIntensityListParams,
} = slice.actions;
